import React from "react";
import toast from "react-hot-toast";
import { withRouter } from "react-router-dom";
import CopyIcon from "../../../../assets/svg/icons/common/copy";
import Modal from "../../../../components/modal";
import useDomainStore from "../../../../stores/domain";
import styles from "./style.module.scss";

const SendLinkMerchantModal = ({
  onClose,
  isOpen,
  onContinue,
  history,
  location,
  match,
  applicationURL,
  continueBtnTxt = 'Continue',
}) => {
  const { isKurvDomain } = useDomainStore();
  const copyLink = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard", {
        duration: 2000,
        removeDelay: 0,
      });
    } catch (error) {
      console.error("There was a problem copying text");
      console.error(error.message);
    }
  };

  const handleContinue = () => {
    onClose();
    if (onContinue && typeof onContinue === "function") {
      onContinue();
      return;
    }
    // Navigate to create-pre-app
    history.push("/v2/create-pre-app");
  };

  const handleGoToApplications = () => {
    onClose();
    history.push("/applications");
  };

  const header = (
    <div className={styles.header}>
      <h1 className={styles.title}>Link sent to Merchant</h1>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      size="small"
      customClass={styles.modalCustom}
    >
      <div className={`${styles.body} ${isKurvDomain ? styles.kurv_theme : ""}`}>
        <div className={styles.head}>
          <div className={styles.successIcon}>
            <div className={styles.successIconInner1}>
              <div className={styles.successIconInner2}>
                <div className={styles.successIconInner3}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.2859 14.7186L18.1648 6.83887L19.3776 8.05087L10.2859 17.1426L4.83105 11.6877L6.04305 10.4757L10.2859 14.7186Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <p className={styles.text}>
            Pre-Application has been sent to the merchant. If you have all the
            data, you can fill out the application yourself, to do this, click
            "Continue".
          </p>
        </div>

        <div className={styles.copyLinkContainer}>
          <div className={styles.left}>{applicationURL}</div>
          <div className={styles.right}>
            <button
              onClick={(e) => {
                copyLink(applicationURL);
              }}
              className={styles.copyButton}
              type="button"
            >
              <CopyIcon />
              <span className={styles.buttonText}>Copy link</span>
            </button>
          </div>
        </div>
      </div>

      <div className={`${styles.footer} ${isKurvDomain ? styles.kurv_theme : ""}`}>
        <div className={styles.actions}>
          <button
            type="button"
            onClick={handleContinue}
            className={styles.continueButton}
          >
            {continueBtnTxt}
          </button>
          <button
            type="button"
            bgColor={isKurvDomain ? "#22a276" : "#4c70ef"}
            onClick={handleGoToApplications}
            className={styles.applicationsButton}
          >
            Go to Applications
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default withRouter(SendLinkMerchantModal);
